module.exports = __webpack_public_path__ + "images/mdj/members/resume/common/common_icon03-8d224a3db2476f5b72e92ea41217ba65.png";